import { Flex, FlexProps, Text } from '@chakra-ui/react';
import React from 'react';

type Props = FlexProps & {
  children: React.ReactNode;
  counter: number;
  total: number;
  text: string;
};

export default function ProgressCounter(props: Props) {
  const { children, counter, total, text, ...rest } = props;
  return (
    <Flex
      padding={['1.875rem 0rem', '1.875rem 0rem', '1.875rem 2.5rem']}
      align="center"
      gap="2rem"
      flexDirection={['column', 'column', 'row']}
      {...rest}
    >
      <Flex justifyContent="space-between" align="center" gap="2rem">
        {children}
      </Flex>

      <Flex flexShrink="0" flexGrow="1" align="center" justify="space-between">
        <Text fontSize={['0.9rem']}>{`${text} ${counter} de ${total}`}</Text>
        <Flex height="0.5rem" w={['60%', '60%', '80%']} bg="gray.100">
          <Flex
            bg="orange.500"
            width={`${(counter * 100) / total}%`}
            height="100%"
            transition="width"
            transitionDuration="300ms"
          ></Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
